import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			projectsHeroContentSectionHeaderBigV1Cls: string;
			projectsHeroContentSectionSubheaderBigCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Projects Details Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsHeroContentSectionHeaderBigV1Cls || '', 'projects_hero', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.projectsHeroContentSectionSubheaderBigCls || '', 'projects_hero', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;